import request from "@/utils/request";
import qs from 'qs'

/**查询客商结算公司表**/
export function querySpOrderStatus(data) {
    return request({
        url: '/web/status/querySpOrderStatus',
        method: 'post',
        data: qs.stringify(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

export function querySpOrderStatusByGoOrderId(data) {
  return request({
    url: '/web/status/querySpOrderStatusForDashBoard',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
